"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusionTableTopBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var paginationContext_1 = require("../../../../../../../contexts/paginationContext");
var main_1 = require("../../../../../../../reducers/slices/main");
var routes_1 = require("../../../../../../../constants/routes");
var react_3 = __importStar(require("react"));
var import_excluded_products_1 = require("../import_excluded_products");
var export_excluded_products_1 = require("../../../../../../../api/calls/product/export_excluded_products");
var download_file_1 = require("../../../../../../../api/calls/product/download_file");
var delete_all_excluded_products_1 = require("../delete_all_excluded_products");
var delete_1 = require("../../../../../../../components/icons/delete");
var ExclusionTableTopBar = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var totalPages = (0, paginationContext_1.usePaginationContext)().totalPages;
    var pageTitle = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).pageTitle;
    var actionButtons = (0, react_3.useMemo)(function () { return [
        {
            iconClassname: "solar:add-circle-bold",
            label: "Add Product",
            onClick: function () {
                navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.EXCLUDED_PRODUCT_DETAILS_ROUTE));
            },
        },
        {
            iconClassname: "solar:cloud-upload-bold",
            label: "Import CSV",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Import Excluded Products",
                    content: react_3.default.createElement(import_excluded_products_1.ImportExcludedProductsComponent),
                }));
            },
        },
        {
            iconClassname: "solar:cloud-download-bold",
            label: "Export CSV",
            onClick: function () {
                (0, export_excluded_products_1.get_download_url)()
                    .then(function (data) {
                    (0, download_file_1.download_file)(data.content)
                        .then(function (response) {
                        var blob = new Blob([response.file_data], { type: "application/octet-stream" });
                        var url = window.URL.createObjectURL(blob);
                        var link = document.createElement("a");
                        link.href = url;
                        link.download = response.file_name;
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                        .catch(function (e) {
                        console.log("download_file: ", e);
                    });
                })
                    .catch(function (error) {
                    console.log("get_download_url: ", error);
                });
            },
        },
        {
            iconClassname: "solar:trash-bin-2-bold",
            label: "Delete All",
            key: "delete_all",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Confirm deletion of ALL products",
                    content: react_3.default.createElement(delete_all_excluded_products_1.DeleteAllExcludedProductsComponent),
                }));
            },
        },
    ]; }, []);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "mb-[18px] flex items-center justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex w-[400px] items-center gap-2" }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ className: "text-2xl font-[700] leading-[32px]" }, { children: pageTitle })), (0, jsx_runtime_1.jsx)(react_2.Chip, __assign({ className: "hidden items-center text-default-500 sm:flex", size: "sm", variant: "flat" }, { children: totalPages }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-end gap-4" }, { children: actionButtons.map(function (button, index) { return ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: button.key === "delete_all" ? "default" : "primary", onClick: button.onClick, endContent: button.key == "delete_all" ? ((0, jsx_runtime_1.jsx)(delete_1.DeleteFilledIcon, { onClick: button.onClick, className: "cursor-pointer text-default-400", height: 18, width: 18, color: "black" })) : ((0, jsx_runtime_1.jsx)(react_1.Icon, { icon: button.iconClassname, width: 20 })) }, { children: button.label }), index)); }) }))] })));
};
exports.ExclusionTableTopBar = ExclusionTableTopBar;
